module.exports = __webpack_public_path__ + "static/media/Visa.b4e78299.svg";